export default "__VITE_ASSET__Beg1T0S8__"